import { makeStyles } from "@material-ui/core/styles";

const signupAndLoginStyles = makeStyles(() => ({
  loginContainer: {
    width: "100vw",
    height: "100vh",
    background: "#252A38",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    isolation: "isolate",
    fontFamily: "Poppins",
  },

  glow: {
    position: "absolute",
    width: 500,
    height: 600,
    background: "#6C65D9",
    filter: "blur(300px)",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 0,
    borderRadius: "50%",
  },

  topLogo: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
    marginBottom: 24,
  },

  brand: {
    color: "#F9F9F9",
    fontFamily: "Poppins !important",
    fontWeight: "600 !important",
    fontSize: "24px !important",
  },

  loginCard: {
    background: "#1B1D28 !important",
    borderRadius: "20px !important",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 2,
  },

  cardContent: {
    padding: "32px !important",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 32,
    width: "90%",
  },

  headerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  welcomeTitle: {
    fontFamily: "Poppins !important",
    color: "#F9F9F9",
    fontWeight: "500 !important",
    fontSize: "24px !important",
  },

  loginForm: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    width: "100%",
  },

  inputLabel: {
    color: "#606479",
    fontFamily: "Poppins",
    marginBottom: 6,
  },

  inputWrapper: {
    background: "#252A38",
    borderRadius: 10,
    height: 41,
    padding: "0px 10px",
    display: "flex",
    alignItems: "center",
  },

  input: {
    background: "transparent !important",
    borderRadius: 10,
    fontFamily: "Poppins",
    height: 41,
  },

  primaryButton: {
    width: "100%",
    height: 41,
    background: "#6C65D9",
    borderRadius: 10,
    textTransform: "none",
    color: "#F9F9F9",
    fontFamily: "Poppins",
    transition: "0.2s",
    "&:hover": {
      background: "rgba(238,238,238,0.15)",
      transform: "translateY(-1px)",
    },
    "&:disabled": {
      background: "rgba(238,238,238,0.15)",
      transform: "translateY(-1px)",
    },
  },

  divider: {
    color: "#333",
    width: "100%",
  },

  linksContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },

  smallLink: {
    fontFamily: "Poppins",
    color: "#B1B5C9 !important",
    textDecoration: "underline",
    cursor: "pointer",
  },

  bigLink: {
    fontFamily: "Poppins",
    color: "#F9F9F9 !important",
    textDecoration: "underline",
    cursor: "pointer",
  },

  errorAlert: {
    width: "100%",
  },
}));

export default signupAndLoginStyles;
